import { useQuery } from '@tanstack/react-query'
import { type components } from '@akillidernek/api-client'
import { api } from './api'
import { tenantSlug } from './tenant'

export type Dernek = components['schemas']['PortalTenantRead']

/** Derneğin açılış bilgisi: ad, renk, üyelik tipleri, başvuru alanları. Kimliksiz. */
export function useDernek() {
  return useQuery({
    queryKey: ['portal-tenant', tenantSlug],
    enabled: Boolean(tenantSlug),
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      const { data } = await api.GET('/api/v1/portal/tenant')
      return data
    },
  })
}
